import { DefaultTheme } from '../../../../SaladTheme'

export const aggregateMachineOption = { Aggregate: { isChecked: true, id: 'Aggregate', color: DefaultTheme.green } }
